import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withState } from 'recompose'
import ClickOutside from 'react-click-outside'

import { Button } from 'components'
import { Link } from 'react-router'
import Text from '@hixme-ui/text'
import Container from '@hixme-ui/container'
import Icon from '@hixme-ui/icon'

import { selectors as cartSelectors } from 'store/modules/cart'

import { CartSummaryContainer } from 'containers/CartSummaryContainer'
import ModalSlider from 'components/ModalSlider'
import CartIcon from 'assets/icons/cart.svg'
import classes from './CartSummaryModal.scss'

const enhanced = withState('open', 'setOpen', false)

const CartSummaryModal = enhanced(({ cartSummary, open, setOpen }) => {
  const toggleOpen = () => setOpen(!open)
  const closeModal = () => setOpen(false)

  return (
    <div className={classes.root}>
      <ClickOutside onClickOutside={closeModal}>
        <Container
          flex
          noPadding
          alignItems="center"
          width="160px"
          justifyContent="space-between"
          className={classes.desktopTrigger}
        >
          <span role="button" className={classes.pointer} onClick={toggleOpen}>
            <Text>My Benefits</Text>
          </span>
          <span role="button" onClick={toggleOpen} className={`${classes.circleButton} header-control-surface`}>
            <Text primary large>
              {cartSummary.count}
            </Text>
          </span>
          <span role="button" className={classes.pointer} onClick={toggleOpen}>
            <Icon arrowDown light />
          </span>
        </Container>

        <button
          type="button"
          className={`${classes.mobileTrigger} ${classes.squareButton} header-control-surface`}
          onClick={toggleOpen}
          aria-label={`My Benefits, ${cartSummary.count} items`}
        >
          <CartIcon className={classes.cartIcon} />
          <span className={`${classes.mobileBadge} header-control-surface`}>
            <Text primary>{cartSummary.count}</Text>
          </span>
        </button>
        <ModalSlider
          defaultClassName={classes.open}
          openClassName={classes.open}
          onClose={toggleOpen}
          open={open}
        >
          <Text div jumbo fontWeight="600" style={{ marginBottom: '25px', color: '#3a4951' }}>
            My Benefits Summary
          </Text>
          <CartSummaryContainer />
          <br />
          <Button to="/cart" variant="primary" block onClick={toggleOpen}>
            Go to My Benefits
          </Button>
        </ModalSlider>
      </ClickOutside>
    </div>
  )
})

CartSummaryModal.propTypes = {
  cartSummary: PropTypes.object,
}

const mapStateToProps = (state) => ({
  cartSummary: cartSelectors.getCartSummary(state),
})

export default connect(mapStateToProps)(CartSummaryModal)
